import { render, staticRenderFns } from "./SplashFooter.vue?vue&type=template&id=8a3f9e1e&scoped=true&"
import script from "./SplashFooter.vue?vue&type=script&lang=js&"
export * from "./SplashFooter.vue?vue&type=script&lang=js&"
import style0 from "./SplashFooter.vue?vue&type=style&index=0&id=8a3f9e1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3f9e1e",
  null
  
)

export default component.exports